export default "__VITE_ASSET__869881de__"